import { AfterViewInit, Component, OnInit, inject, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SHARED_COMPONENTS_IMPORTS } from '../index';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { AccessControlCSRParam, CSRParamsPayload, ProxyRegistrationPayload, WidgetConfig } from '../../../tpi-models/general/davinci';
import { DavinciWidgetService } from '../../../tpi-services/davinci/davinci-widget.service';
import { LoggerService } from '../../../tpi-services/logger/logger.service';

@Component({
    selector: 'tpi-davinci-widget',
    templateUrl: './davinci-widget.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ...SHARED_COMPONENTS_IMPORTS]
})

export class DavinciWidgetComponent implements AfterViewInit, OnInit {
    davinciEnvironment = environment;
    readonly type = input<string>(environment.davinci.csrWidget);
    readonly widgetConfig = input<WidgetConfig>(undefined);
    widgetID: string = environment.davinci.csrWidget;
    private davinciService = inject(DavinciWidgetService);
    private davinciToken: string;
    private loggerService = inject(LoggerService);

    ngOnInit(): void {
        switch (this.type()) {
            case environment.davinci.selfServiceWidget:
                this.widgetID = environment.davinci.selfServiceWidget;
                break;
            case environment.davinci.proxyRegistrationWidget:
                this.widgetID = environment.davinci.proxyRegistrationWidget;
                break;
        }

    }

    ngAfterViewInit(): void {
        if (this.widgetConfig()?.user) {
            this.loggerService.info(`davinci csr loaded`, { user: this.widgetConfig()?.user });
        } else {
            this.loggerService.info(`davinci self service loaded`);
        }

        let davinciPayload;
        switch (this.type()) {
            case environment.davinci.csrWidget:
                davinciPayload = new CSRParamsPayload({
                    nwAccountURI: this.widgetConfig().user.userId,
                    csrID: sessionStorage.getItem('userName') ?? '',
                    accessControl: this.widgetConfig().accessControl as AccessControlCSRParam
                });
                break;
            case environment.davinci.selfServiceWidget:
                davinciPayload = { username: sessionStorage.getItem('userName') };
                break;
            case environment.davinci.proxyRegistrationWidget:
                davinciPayload = new ProxyRegistrationPayload(this.widgetConfig().potentialNewUser);
                break;
        }

        // request token and render when available
        this.davinciService.getDavinciToken(davinciPayload, this.type()).subscribe({
            next: (response: any) => {
                this.davinciToken = response?.access_token;
                if (this.davinciToken) {
                    // renderWidget will call initializeWidgetManager(...).renderWidget(token)
                    // service handles the DOM element lookup and widget API call
                    this.davinciService.renderWidget(this.davinciToken, this.type());
                } else {
                    this.loggerService.info(`No access_token in getDavinciToken response`);
                }
            },
            error: (err: any) => {
                this.loggerService.info(`Davinci token error`, { error: err });
            }
        });
    }
}